"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useContactFeaturesContext = exports.ContactFeaturesContext = void 0;
var _reactUtils = require("@cian/react-utils");
const {
  useContext: useContactFeaturesContext,
  Context: ContactFeaturesContext
} = (0, _reactUtils.makeContextModule)({
  contextName: 'ContactFeaturesContext',
  defaultValue: {
    background: 'gray6_100'
  }
});
exports.ContactFeaturesContext = ContactFeaturesContext;
exports.useContactFeaturesContext = useContactFeaturesContext;